import React, { useState, useEffect } from "react";
import EmployeeList from "../../components/EmployeeList/EmployeeList";
import NewEmployeeForm from "../../forms/NewEmployeeForm/NewEmployeeForm";
import { getAllSpecializations } from "../../../redux/specializations/actions";
import { connect } from "react-redux";
import { getSpecialtiesSelector } from "../../../redux/specializationMapping/selectors";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom"
import { getEmployeesByFilter } from "../../../redux/employees/actions";
import useUpdateEffect from "../../../hooks/useUpdateEffect";
import { compose } from "redux";
import { createHistoryPush } from "../../../helpers/functions";

const Employees = ({
  getAllSpecializations,
  getEmployeesByFilter,
  specialities,
  pageCount,
  items,
}) => {
  const [edit, setEdit] = useState(false);
  const [blob, setBlob] = useState(null);
  const [addingImg, setAddingImg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newlyCreatedEmployeeId, setNewlyCreatedEmployeeId] = useState(null);
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()
  const page = searchParams.get("page")
  const filter = searchParams.get("filter")
  const specialties = searchParams.get("specialties")
  
  useEffect(() => {
    getAllSpecializations(50)
    // eslint-disable-next-line
  }, []);

  const refreshEmployees = ({firstTime}) => {
    setLoading(true)
    getEmployeesByFilter({filter, page, specs: specialties, firstTime})
      .finally(() => setLoading(false))
  }

  useEffect(() => refreshEmployees({firstTime: true}), [])
  useUpdateEffect(() => refreshEmployees({firstTime: false}), [page, filter, specialties])

  // Check if requested page is higher than available pages and redirect to last page
  useEffect(() => {
    const requestedPage = parseInt(page) || 1;
    if (pageCount && requestedPage > pageCount && pageCount > 0) {
      // Redirect to last available page
      createHistoryPush({
        location,
        navigate,
        page: pageCount,
        filter,
        specialties,
      });
    }
  }, [pageCount, page, filter, specialties, location, navigate]);

  // Clear newly created employee ID after highlighting animation
  useEffect(() => {
    if (newlyCreatedEmployeeId) {
      const timer = setTimeout(() => {
        setNewlyCreatedEmployeeId(null);
      }, 4000); // Clear after 4 seconds (slightly longer than animation)
      
      return () => clearTimeout(timer);
    }
  }, [newlyCreatedEmployeeId]);

  return (
    <div className="employeeContainer flex justifyBeetwen">
      {specialities && specialities.length >= 1 && (
        <>
          <EmployeeList
            edit={edit}
            setEdit={() => setEdit(true)}
            specialities={specialities}
            setAddingImg={setAddingImg}
            setBlob={setBlob}
            currentPage={page}
            currentFilter={filter}
            currentTags={specialties ? specialties : ""}
            loading={loading}
            newlyCreatedEmployeeId={newlyCreatedEmployeeId}
          />
          <NewEmployeeForm
            edit={edit}
            setEditingOff={() => setEdit(false)}
            specialities={specialities}
            setAddingImg={setAddingImg}
            addingImg={addingImg}
            setBlob={setBlob}
            blob={blob}
            onNewEmployeeCreated={setNewlyCreatedEmployeeId}
          />
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  specialities: getSpecialtiesSelector(state),
  pageCount: state.employees && state.employees.page_count,
  items: state.employees && state.employees.items,
})

const enhance = compose( connect(mapStateToProps, {
  getAllSpecializations,
  getEmployeesByFilter,
}));

export default enhance(Employees);

// export default connect(mapStateToProps, )(Employees);
